'use client';

import {
	createContext,
	useCallback,
	useContext,
	useState,
	type ReactNode,
} from 'react';

import { AuthModal } from './AuthModal';

type Mode = 'login' | 'register';

interface AuthModalApi {
	open: (mode: Mode) => void;
}

const AuthModalContext = createContext<AuthModalApi | null>(null);

export function useAuthModal(): AuthModalApi {
	const ctx = useContext(AuthModalContext);
	if (!ctx) {
		throw new Error('useAuthModal must be used within an AuthModalProvider');
	}
	return ctx;
}

export function AuthModalProvider({ children }: { children: ReactNode }) {
	const [mode, setMode] = useState<Mode | null>(null);
	const open = useCallback(() => setMode('login'), []);
	const close = useCallback(() => setMode(null), []);

	return (
		<AuthModalContext.Provider value={{ open }}>
			{children}
			{mode && <AuthModal mode={mode} onClose={close} />}
		</AuthModalContext.Provider>
	);
}
